import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'licens',
    templateUrl: './licens.component.html',
    styleUrls: ['./licens.component.scss']
})
export class LicensComponent implements OnInit {

    constructor() {}

    ngOnInit() {}

}
